<script setup lang="ts">
    import { computed } from 'vue';

    /* Props the parent form will pass */
    const props = defineProps<{
        modelValue?: boolean | unknown[];
        fieldProps?: object;
        label?: string;
        color?: string;
        border?: boolean;
        hideDetails?: true;
        value?: number | string | object;
        disabled?: boolean;
        direction?: 'horizontal' | 'vertical';
        density?: 'default' | 'compact' | 'comfortable';
    }>();

    const emit = defineEmits<(e: 'update:modelValue', v: boolean | unknown[]) => void>();
    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: boolean | unknown[]) => emit('update:modelValue', val),
    });
</script>

<template>
    <v-checkbox
        v-model="innerValue"
        v-bind="props.fieldProps"
        :label="props.label"
        :value="props.value"
        :disabled="props.disabled"
        :style="{ border: props.border ? '1px solid black' : 'none' }"
        :class="props.border ? 'checkboxBorder' : ''"
        :color="props.color"
        :hide-details="props.hideDetails || props.border"
        :direction="props.direction"
        :density="props.density"
    >
        <template #label>
            <slot v-if="$slots.default" />
            <span v-else>{{ props.label }}</span>
        </template>
    </v-checkbox>
</template>
